import styled, { css } from 'styled-components';
import { devices } from '../../const/devices';

export const InAppLayoutContainer = styled.div`
	display: grid;
	grid-template:
		'header  header' 64px
		'sidebar content' calc(100% - 64px) /
		auto 1fr;

	overflow: hidden;

	height: 100%;

	@media ${devices.tablet} {
		grid-template:
			'header' 64px
			'content' calc(100% - 164px)
			'footer' 100px /
			1fr;
	}
`;

export const MainContentLayout = styled.main`
	grid-area: content;
	overflow-y: auto;
	overflow-x: hidden;
	min-height: 100%;
	background-color: #f5f5f5;
`;

export const OutAppLayoutContainer = styled.div<{ $hasHeader: boolean }>`
	display: grid;

	overflow: hidden;
	height: 100%;

	${({ $hasHeader }) =>
		$hasHeader
			? css`
					grid-template:
						'header' 64px
						'content' calc(100% - 64px) /
						1fr;
				`
			: css`
					grid-template:
						'content' 100% /
						1fr;
				`};

	& > main {
		padding: 1rem;
		background: linear-gradient(45deg, rgba(255, 255, 255, 1) 0%, rgba(240, 248, 255, 1) 100%);
	}
`;
